(()=>{
  if(window.goReferenceQuantityLoaded)return;
  window.goReferenceQuantityLoaded=true;
  function enhance(){
    document.querySelectorAll('.product-details .quantity-selector-wrapper:not(.gl-pdp-quantity-ready)').forEach(wrapper=>{
      const input=wrapper.querySelector('input[name="quantity"]');
      if(!input)return;
      const min=Number(input.min)||1, step=Number(input.step)||1;
      const max=input.max?Number(input.max):Math.max(20,Number(input.value));
      if((max-min)/step>200 || max<min)return;
      const select=document.createElement('select');select.className='gl-pdp-quantity';select.setAttribute('aria-label','Quantità');
      for(let n=min;n<=max;n+=step){const option=new Option(String(n),String(n));select.add(option)}
      select.value=input.value;select.disabled=input.disabled;
      select.addEventListener('change',()=>{input.value=select.value;input.dispatchEvent(new Event('change',{bubbles:true}));input.dispatchEvent(new FocusEvent('blur',{bubbles:true}));});
      wrapper.append(select);wrapper.classList.add('gl-pdp-quantity-ready');
    });
  }
  enhance();
  let scheduled=false;
  const root=document.querySelector('.product-details');
  if(root)new MutationObserver(()=>{if(!scheduled){scheduled=true;requestAnimationFrame(()=>{scheduled=false;enhance()})}}).observe(root,{childList:true,subtree:true});
})();
